import { apiClient } from "../config";

async function getAllPrograms(searchQuery?: string) {
  const params = {
    searchString: searchQuery,
    entity: "programs",
  };
  
  const res = await apiClient.get(`/admin/users/drop-down`, { params });
  return res.data;
}

export default getAllPrograms;
